import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

interface SlideData {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  image: string;
  mobileImage?: string; // Optional for mobile-specific images
  ctaText: string;
  ctaLink: string;
  textPosition: 'left' | 'right' | 'center';
}

@Component({
  selector: 'app-main-slider',
  templateUrl: './main-slider.component.html',
  styleUrls: ['./main-slider.component.scss']
})
export class MainSliderComponent implements OnInit, OnDestroy {
  currentIndex = 0;
  slides: SlideData[] = [
    {
      id: 1,
      title: 'Collection Automne',
      subtitle: 'Nouvelle Saison',
      description: 'Découvrez notre nouvelle collection automne avec des pièces tendance et confortables',
      image: 'https://www.laparfumerie.eu/media/wysiwyg/HERMES_TDH_3.jpg',
      mobileImage: 'https://www.laparfumerie.eu/media/wysiwyg/HERMES_TDH_2.jpg',
      ctaText: 'Découvrir',
      ctaLink: '/collection/automne',
      textPosition: 'left'
    },
    {
      id: 2,
      title: '50% de Réduction',
      subtitle: 'Offre Limitée',
      description: 'Profitez de nos soldes exceptionnels sur une sélection d\'articles mode',
      image: 'https://www.laparfumerie.eu/media/wysiwyg/CARON_OCA_1.jpg',
      ctaText: 'Voir les Offres',
      ctaLink: '/soldes',
      textPosition: 'center'
    },
    {
      id: 3,
      title: 'Parfums de Luxe',
      subtitle: 'Collection Exclusive',
      description: 'Explorez notre sélection de parfums de luxe et trouvez votre signature olfactive',
      image: 'https://www.laparfumerie.eu/media/wysiwyg/JPG-LE-MALE_6.jpg',
      ctaText: 'Explorer',
      ctaLink: '/parfums',
      textPosition: 'right'
    },
    {
      id: 4,
      title: 'Coffrets Cadeaux',
      subtitle: 'Idées Cadeaux',
      description: 'Découvrez nos coffrets cadeaux élégants pour toutes les occasions',
      image: 'https://www.laparfumerie.eu/media/wysiwyg/GUERLAIN_desktop_3.jpg',
      ctaText: 'Voir les Coffrets',
      ctaLink: '/coffrets',
      textPosition: 'left'
    }
  ];

  private autoPlayInterval: any;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.startAutoPlay();
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
  }

  startAutoPlay(): void {
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  stopAutoPlay(): void {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
  }

  nextSlide(): void {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }

  previousSlide(): void {
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
  }

  goToSlide(index: number): void {
    this.currentIndex = index;
  }

  navigateTo(link: string): void {
    this.router.navigate([link]);
  }

  trackById(index: number, slide: SlideData): number {
    return slide.id;
  }
}
